export default "__VITE_ASSET__CIAIcjdq__"